import 'rc-slider/assets/index.css'
import React from 'react'
import Slider from 'rc-slider'

// eslint-disable-next-line react/display-name
export default (props) => {
  const handleChange = (newValue) => props.onChange(props.name, newValue)

  const { onChange, label, displayValue, ...rest } = props
  return (
    <div>
      <label className='label'>{label}</label>
      {displayValue && <div className='mb-2'>{displayValue}</div>}
      <div className='col'>
        <Slider onChange={handleChange} {...rest} />
      </div>
    </div>
  )
}
